export default class {
    cache = new Map();

    get(key) {
        const val = this.cache.get(key);

        if(val) {
            if(val.expires && val.expires < new Date().valueOf()) {
                this.cache.delete(key);
                return null;
            } else {
                return val.value;
            }
        } else {
            return null;
        }
    }

    set(key, val, expiresIn) {
        this.cache.set(key, {value: val, expires: expiresIn ? new Date().valueOf() + expiresIn : null})
    }
}